





















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import CopyText from '@/components/misc/CopyText.vue'

@Component({
    components: { CopyText },
})
export default class HTTPError extends Vue {
    @Prop() title!: string
    @Prop() status?: number
    @Prop() message?: string
    @Prop() id!: string
    @Prop() supportURL!: string
    @Prop() isMargin?: boolean

    shortenText(source: string, index1: number, index2: number) {
        if (index2 >= source.length) return source

        return `${source.substring(0, index1)}...${source.substring(
            source.length - index2,
            source.length
        )}`
    }
}
